/* stellar-cab.js: the cabinet (list of collections), v2.
   Ask the bar (three questions that dim the shelves to the bottles that fit), the list that follows the room (rail and strip),
   the rare stage (one bottle at a time). Events go through the site data layer (stellar-data.js) when it is present.
   The shooting stars in empty media boxes are drawn by stellar-shop.js. */
(function () {
  'use strict';
  function trk(event, data, opts) { if (window.stellar && window.stellar.track) return window.stellar.track(event, data, opts); }

  /* ---- ask the bar ---- */
  function ask(root) {
    if (root.dataset.sxcOn) return; root.dataset.sxcOn = '1';
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-q]')), bar = root.querySelector('[data-bar]'), back = root.querySelector('[data-back]'), pickline = root.querySelector('[data-pickline]');
    var words = {}; try { words = JSON.parse(root.getAttribute('data-words') || '{}'); } catch (e) { words = {}; }
    var A = {}, q = 0, last = steps.length - 1;
    function show(n) {
      q = n; steps.forEach(function (s, i) { s.hidden = i !== n; });
      if (bar) bar.style.width = (n >= last ? 100 : Math.round((n + 1) / last * 100)) + '%';
      if (back) back.hidden = n === 0; if (pickline) pickline.hidden = n === last;
    }
    function band(v) { var m = String(v || '').match(/^(\d*)-(\d*)$/); return m ? [m[1] === '' ? -1 : parseFloat(m[1]), m[2] === '' ? Infinity : parseFloat(m[2])] : null; }
    function fits(el) {
      var f = A.lean, o = A.evening, p = A.bottle, pr = parseFloat(el.getAttribute('data-price'));
      if (f && f !== 'any' && el.getAttribute('data-family') !== f) return false;
      if (o && o !== 'any' && (' ' + el.getAttribute('data-occ') + ' ').indexOf(' ' + o + ' ') < 0) return false;
      var b = band(p); if (b && (pr < b[0] || pr > b[1])) return false;
      return true;
    }
    function apply() {
      var all = document.querySelectorAll('.sxc-bottle'), n = 0, first = null;
      all.forEach(function (el) { var ok = fits(el); el.classList.toggle('is-out', !ok); if (ok) { n++; if (!first) first = el; } });
      var c = root.querySelector('[data-count]'); if (c) c.textContent = n;
      var line = root.querySelector('[data-line]');
      if (line) line.textContent = (words[A.evening] || '') + (A.lean && A.lean !== 'any' && words[A.lean] ? (words[A.evening] ? ', ' : '') + words[A.lean] : '') + ((words[A.evening] || words[A.lean]) ? '.' : '');
      var go = root.querySelector('[data-go]'); var ch = first && first.closest('[data-chapter]');
      if (go && ch) go.href = '#' + ch.id;
      trk('cabinet_asked', { evening: A.evening, lean: A.lean, bottle: A.bottle, matches: n }, { el: root, now: true });
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('.sxc-opt');
      if (o) {
        A[o.getAttribute('data-pick')] = o.getAttribute('data-val');
        o.parentNode.querySelectorAll('.sxc-opt').forEach(function (x) { x.classList.toggle('on', x === o); });
        setTimeout(function () { if (q === last - 1) { apply(); show(last); } else show(q + 1); }, 260);
        return;
      }
      if (e.target.closest('[data-back]')) { show(Math.max(0, q - 1)); return; }
      if (e.target.closest('[data-reset]')) {
        A = {}; root.querySelectorAll('.sxc-opt').forEach(function (x) { x.classList.remove('on'); });
        document.querySelectorAll('.sxc-bottle').forEach(function (el) { el.classList.remove('is-out'); });
        show(0); trk('cabinet_reset', {}, { el: root }); return;
      }
    });
    show(0);
  }

  /* ---- the list follows the room ---- */
  function list(root) {
    if (root.dataset.sxcOn) return; root.dataset.sxcOn = '1';
    var links = root.querySelectorAll('[data-to]'), rail = root.querySelector('[data-rail]');
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-chapter]'));
    if (!chapters.length || !('IntersectionObserver' in window)) return;
    function mark(id) { links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('data-to') === id); }); }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) mark(en.target.getAttribute('data-chapter')); }); }, { rootMargin: '-40% 0px -50% 0px' });
    chapters.forEach(function (c) { io.observe(c); });
    if (rail) new IntersectionObserver(function (es) { es.forEach(function (en) { rail.classList.toggle('is-on', en.boundingClientRect.top < 0 || en.isIntersecting); }); }, { threshold: 0 }).observe(chapters[0]);
    root.addEventListener('click', function (e) { var a = e.target.closest('[data-to]'); if (a) trk('cabinet_chapter_clicked', { chapter: a.getAttribute('data-to') }, { el: a }); });
  }

  /* ---- the rare stage: one bottle at a time ---- */
  function stage(root) {
    if (root.dataset.sxcOn) return; root.dataset.sxcOn = '1';
    var pieces = Array.prototype.slice.call(root.querySelectorAll('[data-piece]')), links = Array.prototype.slice.call(root.querySelectorAll('[data-piece-link]')), imgs = Array.prototype.slice.call(root.querySelectorAll('[data-piece-img]')), picks = root.querySelectorAll('[data-i]');
    function show(i) {
      pieces.forEach(function (p, k) { p.hidden = k !== i; });
      links.forEach(function (p, k) { p.hidden = k !== i; });
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      picks.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    }
    root.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (!b) return; var i = parseInt(b.getAttribute('data-i'), 10); show(i); trk('cabinet_rare_picked', { bottle: b.textContent.trim() }, { el: b }); });
    show(0);
  }

  function init(root) {
    root.querySelectorAll('[data-cab-ask]').forEach(ask); if (root.matches('[data-cab-ask]')) ask(root);
    root.querySelectorAll('[data-cab-room]').forEach(list); if (root.matches('[data-cab-room]')) list(root);
    root.querySelectorAll('[data-cab-stage]').forEach(stage); if (root.matches('[data-cab-stage]')) stage(root);
  }
  function boot() { document.querySelectorAll('[data-sxc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-sxc]').forEach(init); });
})();
